var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"info",attrs:{"block":""},on:{"click":_vm.liquidarFinanciamiento}},[_vm._v(" Liquidar ")])}
var staticRenderFns = []

export { render, staticRenderFns }